import * as React from 'react';
import UpgradeBadge from './UpgradeBadge';

export const upgradeBadge = () => <UpgradeBadge />;

export default {
    title: 'Components/Badges/UpgradeBadge',
    component: UpgradeBadge,
};
